export const endpoint = {
  agui: 'agui'
};

export const DEFAULT_CONTEXT = "create_draft";

export const AiChatAssistantTranslation = {
  textThinking: 9851,
  textClearChat: 9852,
  textRegisterCase: 9853,
  textAiChatAssistantPlaceholder: 9854,
  textCreatingDraft: 9855,
  textNoResponse: 9856,
  textAiChatAssistantEndpointError: 9857,
  textRegisterNewCase: 5328
};

export const AiChatAssistantTextAreaMaxLength = 8000;
